module.exports = __webpack_public_path__ + "static/media/fj.60adb099.svg";